<template>
  <div class="questions-container">
    <CCard>
      <CCardHeader>
        <CRow>
          <CCol md="3" sm="12">
            <h1>{{ $t('QUESTION_LIST_PAGE_TITLE') }}</h1>
          </CCol>
          <CCol md="6" sm="12"></CCol>
          <CCol md="3" sm="12">
            <CButton class="btn btn-success btn-add-new" @click="addNewQuestion()">+ {{ $t('QUESTION_LIST_PAGE_ADD_NEW') }}</CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <SearchQuestionHeader :onSearch="onSearch" :questionCatList="questionCatList" :questionTypeList="questionTypeList" />
        <QuestionListTable
          :limit="limit"
          :activePage="activePage"
          :items="items"
          :total="total"
          :isAllowedDel="isAllowedDel"
          :getQuestions="getQuestions"
        />
        <StakingPagination
          :limit="limit"
          :total="total"
          :activePage="activePage"
          @changePage="onChangePage"
          @changePageSize="onChangePageSize"
        />
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { endpoints, env, Constants } from '@/constants';
import QuestionListTable from '@/components/Questions/QuestionListTable';
import SearchQuestionHeader from '@/components/Questions/SearchQuestionHeader';
import StakingPagination from '@/components/StakingPagination';
import stringHelper from '@/utils/string-helper';
import responseHelper from '@/utils/response-helper';

export default {
  name: 'QuestionList',
  components: {
    SearchQuestionHeader,
    QuestionListTable,
    StakingPagination,
  },
  data() {
    return {
      items: [],
      questionCatList: [],
      questionTypeList: [],
      filterData: {},
      total: 0,
      limit: env.app.pageSize,
      activePage: 1,
      isAllowedDel: false,
    };
  },
  computed: {
    offset() {
      return (this.activePage - 1) * this.limit;
    },
    pages() {
      return Math.ceil(this.total / this.limit);
    },
     ...mapGetters(['userPermissions']),
  },
  async mounted() {
    this.checkPermissions();
    await Promise.all([this.getQuestionsCats(), this.getQuestionsTypes()]);
    this.isLoading = false;
  },
  methods: {
    checkPermissions() {
      if (this.userPermissions.length > 0) {
        this.userPermissions.forEach(item => {
          if (item.name === 'DELETE_QUESTION') {
            this.isAllowedDel = true;
          }
        });
      }
    },
    async getQuestionsCats() {
      try {
        const result = await this.$http.get(endpoints.getQuestionsCats);
        this.questionCatList = stringHelper.translateTextForDropdownList(result.data, 'QUESTION_CAT');
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('QUESTION_LIST_PAGE_ERROR_TITLE'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    async getQuestionsTypes() {
      try {
        const result = await this.$http.get(endpoints.getQuestionsTypes);
        this.questionTypeList = stringHelper.translateTextForDropdownList(result.data, 'QUESTION_TYPE');
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('QUESTION_LIST_PAGE_ERROR_TITLE'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },

    async getQuestions(data) {
      data = data || {};
      this.filterData = {
        ...this.filterData,
        ...data,
      };
      const filterData = this.filterData;

      try {
        const params = {
          limit: this.limit,
          offset: this.offset,
          keyword: filterData.keyword,
          category_type: filterData.category_type,
          question_type: filterData.question_type,
        };
        const result = await this.$http.get(endpoints.getQuestions, { params });

        this.items = result.data.items || [];
        this.total = result.data.total;
      } catch (err) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: this.$t('QUESTION_LIST_PAGE_ERROR_TITLE'),
          text: responseHelper.getErrorMessage(err),
        });
      }
    },
    async onChangePage(page) {
      this.activePage = page;

      this.getQuestions();
    },

    async onChangePageSize(value) {
      this.limit = value;
      this.activePage = 1;

      this.getQuestions();
    },

    async onSearch(searchData) {
      const data = searchData;
      this.activePage = 1;

      this.getQuestions(data);
    },
    addNewQuestion() {
      this.$router.push('questions/create');
    },
  },
};
</script>

<style lang="scss">
.questions-container {
  padding: 0 24px;
  @media screen and (max-width: 1024px) {
    padding: 0 15px;
  }

  .card {
    > .card-header {
      border-bottom: none;
      padding-bottom: 0px;

      h1 {
        color: #657187;
        font-size: 18px;
        font-weight: 600;
        line-height: 34px;
        margin-bottom: 0px;
      }
    }
  }
  .btn-add-new {
    border: none;
    border-radius: 32px;
    height: 32px;
    padding: 0 30px;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 14px;
    text-align: center;
    border-radius: 17.5px;
    min-width: 175px;
    display: block;
    letter-spacing: 0.5px;
    line-height: 16px;
    text-align: center;
    color: #fff;
    border: 1px solid #1a2958;
    border-radius: 17.5px;
    background: #3b4b7e;
    float: right;
  }
}
</style>
